<template lang="pug">
.p_vrot#vr-office-tour
  .p_vrot-bg
  .p_vrot-inner
    section.p_vr
      .c_inner
        .p_vr-inner
          a.p_vpanel(href="https://my.matterport.com/show/?m=TsQ6iijtmLN", target="_blank", v-touch:tap="tap")
            .p_vpanel-col.c_col-pc
              .p_vpanel-image._fade.fade_in.scale
                span.-image
                  img(:src="getImage('/top', '/img_vr.jpg')", alt="")
                i.-icn
                  img(:src="getImage('/common', '/icn_play.png', '')", alt="")
              .p_vpanel-inner.c_col.u_col-ai-c
                .p_vpanel-inner-content._fade.fade_in.scale
                  .p_vpanel-header
                    h2.p_vpanel-heading
                      span.-text ALH Office Tour
                  .p_vpanel-body
                    h3.p_vpanel-body-heading
                      span.-text 360°動画でオフィス見学する
                    .p_vpanel-body-text
                      p このサイトではALH株式会社のオフィスにいるかのようなウォークスルー体験ができます。
                    .p_vpanel-footer
                      p.p_vpanel-more.c_col.u_col-ai-c
                        span.-text View more
                        i.-bar
    section.p_ps#philosophy
      .c_inner
        .p_ps-inner
          .p_ps-header
            .p_ps-header-image._fade.fade_in.scale
              span.-image
                img(:src="getImage('/top', '/img1.jpg')", alt="")
            .p_ps-header-inner._fade.fade_in.scale
              h2.p_ps-heading.c_heading1
                span.p_ps-body-heading-text.c_heading1-text Philosophy
          .p_ps-body._fade.fade_in.scale
            .p_ps-body-inner
              .p_ps-body-text
                p 企業にとってオフィスとは、経営や組織メッセージを発信する重要なメディアだと考えています。このサイトを立ち上げた目的もオフィスの機能性やデザイン性を通して新しい働き方を知ってもらうだけではなく、「我々はこういう企業になっていくんだ！」というメッセージをオフィスで表現したかったからです。今後もさらなるオフィス戦略を実行していきますので、このサイトを通して興味をもって頂けた方々に実際にオフィスに遊びに来て頂き、随所にある我々のメッセージを感じて欲しいと思っています。
</template>

<script>
export default {
  name: 'TheVrOfficeTour',
}
</script>

<style lang="scss">
.p_vpanel {
  @include pc {
    max-width: rem(1200);
    height: rem(240);
    padding: 0 rem(35) 0 0;
    box-sizing: content-box;
  }
  width: 100%;
  margin: 0 auto;
  display: block;
  transition: all .3s ease-in-out;
  position: relative;

  &::before {
    @include pc {
      width: rem(10);
      right: rem(15);
    }
    @include box_shadow();
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    background: $palet1;
    top: 0;
  }

  &::after {
    @include pc {
      width: rem(5);
      right: rem(0);
    }
    @include box_shadow();
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    background: $palet1;
    top: 0;
  }

  &-col {
    @include pc {
      width: calc(100% - 35px);
      height: 100%;
      margin: auto;
      left: 0;
      top: 0;
      position: absolute;
      box-sizing: border-box;
    }
    @include sp {
      position: relative;
    }
    @include box_shadow();
    background: $palet1;
  }

  &-image {
    @include pc {
      width: 50%;
      min-width: 50%;
    }
    width: 100%;
    line-height: 0;
    position: relative;

    .-image {

      @include pc {
        width: 100%;
        height: 100%;
        margin: auto;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        position: absolute;
      }
      line-height: 0;
      display: block;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .-icn {
      @include pc {
        width: rem(67);
        height: rem(82);
      }
      @include sp {
        width: rem(67,2);
        height: rem(82,2);
      }
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      display: block;
      margin: auto;
    }
  }

  &-inner {
    @include pc {
      width: 50%;
      min-width: 50%;
    }
    @include sp {
      padding: rem(15) 0 rem(20);
    }

    &-content {
      @include pc {
        width: cal(497,600);
        max-width: rem(497);
      }
      @include sp {
        width: cal(554,670);
        // max-width: rem(497);
      }
      margin: 0 auto;
    }
  }

  &-header {
    @include pc {
      margin: 0 0 cal(40,497);
    }
    @include sp {
      margin: 0 0 rem(13);
    }
  }

  &-heading {
    .-text {
      @include pc {
        font-size: rem(24);
      }
      @include sp {
        font-size: rem(20);
      }
      @include fo_cus();
      letter-spacing: $ltsp2;
      color: #fff;
    }
  }

  &-body {
    &-inner {
    }

    &-heading {
      @include pc {
        margin: 0 0 cal(14,497);
      }
      @include sp {
        margin: 0 0 rem(18);
      }
      font-size: rem(16);
      font-weight: bold;
      color: #fff;
    }

    &-text {
      color: #fff;
      p {
        @include pc {
          line-height: (24/14);
        }
      }
    }
  }

  &-footer {
    @include pc {
      margin: cal(18,497) 0 0;
    }
    @include sp {
      margin: rem(20) 0 0;
    }
  }

  &-more {
    .-text {
      @include fo_cus();
      color: #fff;
      letter-spacing: $ltsp2;
    }

    .-bar {
      margin: 0 0 0 rem(15);
      width: rem(58);
      height: rem(2);
      display: block;
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        margin: auto;
        top: 0;
        right: 0;
        left: 0;
        background: #fff;
        transform: translateX(-100%);
        animation: hoverTheMoreButton 2s ease-in-out 0s infinite;
        transition: all .3s ease;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        margin: auto;
        top: 0;
        right: 0;
        left: 0;
        background: #fff;
        transition: all .3s ease;
      }
    }

    @keyframes hoverTheMoreButton {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(80px);
      }
    }
  }

  &.tap {
    transform: scale(1.03);
    // transform: translate3d(5px, -5px, 0);
    // transform: translateX(5px);
  }

  &.tap &-more .-bar::before {
    animation: hoverTheMoreButton 2s ease-in-out 0s infinite;
  }
  &.tap &-more .-bar::after {
    opacity: 0;
  }
}
</style>

<style lang="scss" scoped>
.p_vrot {
  @include pc {
    margin: rem(-280) 0 0;
  }
  @include sp {
    // margin: calc(-26.66667vw - 45px) 0 0;
    margin: vw(-200,750) 0 0;
    padding: rem(45) 0 0;
  }
  position: relative;

  &-bg {
    @include mq_min($min_l) {
    }
    @include pc {
      background: url("../../../static/img/top/bg1.png") center top no-repeat;
      background-size: 100% auto;
    }
    @include sp {
      background: url("../../../static/img/top/sp/bg1.png") center top no-repeat;
      background-size: 100% auto;
    }
    width: 100%;
    height: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    top: 0;
    right: 0;
  }

&-inner {}
}

.p_vr {
  width: 100%;
  position: relative;

  &-inner {
    @include pc {
    }
    vertical-align: top;
    position: relative;
  }
}

.p_ps {
  @include pc {
    // padding: rem(60) 0 rem(80);
    padding: rem(60) 0 0;
  }
  @include sp {
    // padding: rem(60,2) 0 rem(105,2);
    padding: rem(60,2) 0 0;
  }
  position: relative;

  &-inner {
    @include pc {
      width: 100;
    }
  }

  &-header {
    @include pc {
      width: cal(960,1200);
      padding: 0 0 rem(120);
    }
    @include sp {
      width: calc(100% - 20px);
      padding: 0 0 vw(140,750);
    }
    position: relative;
    margin: 0;

    &-image {
      line-height: 0;
      position: relative;

      &::before {
        @include pc {
          right: rem(-40);
          bottom: rem(-40);
        }
        @include sp {
          right: rem(-20);
          bottom: rem(-20);
        }
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        background: $palet2;
      }

      .-image {
        position: relative;
      }
    }

    &-inner {
      @include pc {
        right: rem(-40);
        margin: rem(-63) 0 0;
      }
      @include sp {
        right: rem(-20);
        margin: rem(-40,2) 0 0;
      }
      position: absolute;
    }
  }

  &-heading {
    &-text {}
  }

  &-body {
    @include pc {
      width: cal(1000,1200);
      max-width: rem(1000);
      margin: 0 auto;
    }
    &-inner {}

    &-text {
      @include pc {
        text-align: center;
        font-size: rem(16);
      }
      @include sp {
        font-size: rem(14);
      }
      p {
        @include pc {
          line-height: (32/16);
        }
        @include sp {
          line-height: (56/28);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top/TheVrOfficeTour.vue